import { httpPost, httpGet } from '@/utils/requestEx'

export default {
  // 登录
  Login (data) {
    return httpPost('/api/open/auth/login', {
      ...data,
      loading: '正在登录...'
    })
  },

  // KYC 出题
  KYCQuestionnaire (data) {
    return httpGet('/api/open/kyc/questions', {
      ...data,
      loading: '正在获取KYC题目...'
    })
  },

  // 刷新题目
  RefreshQuestions (data) {
    return httpPost('/api/open/kyc/questions/refresh', {
      ...data,
      loading: '刷新中...'
    })
  },

  // 风险类型计算
  RiskType (data) {
    return httpPost('/api/open/kyc/risk-type', {
      ...data,
      loading: '正在计算风险类型...'
    })
  },

  //模型计算
  ModelCalculation (data) {
    return httpPost('/api/open/portfolio/model-calculation', {
      ...data,
      loading: '正在计算模型...'
    })
  },

  //投资组合推荐
  RecommendPortfolio (data) {
    return httpPost('/api/open/recommendation', {
      ...data,
    })
  },

  // 回测 
  Backtest (data) {
    return httpPost('/api/open/portfolio/backtest', {
      ...data,
    })
  },

  // 压力测试 查询历史真实情景
  getHistorical (data) {
    return httpGet('/api/open/portfolio/stress-test/scenarios', {
      ...data,
      loading: '正在查询历史真实情景...'
    })
  },

  // 压力测试 运行压力测试
  StressTest (data) {
    return httpPost('/api/open/portfolio/stress-test', {
      ...data,
    })
  },

  /*
    更新日期：2026-06-16
    需求更新后的新增的api
  */
  //robot-login 机器人人脸登录
  RobotLogin (data) {
    return httpPost('/api/open/auth/robot-login', {
      ...data,
      loading: '正在登录...'
    })
  },

  // visitor-questions 问卷
  VisitorQuestions (data) {
    return httpGet('/api/open/kyc/visitor-questions', {
      ...data,
    })
  },

  // visitor-risk-type 评分
  VisitorRiskType (data) {
    return httpPost('/api/open/kyc/visitor-risk-type', {
      ...data,
    })
  },

  // visitor-model-calculation  模型调整
  VisitorModelCalculation (data) {
    return httpPost('/api/open/portfolio/visitor-model-calculation', {
      ...data,
    })
  },

  // model-metadata 获取指定金融模型的数学逻辑说明与python求解脚本
  ModelMetadata (data) {
    return httpGet('/api/open/portfolio/model-metadata', {
      ...data,
    })
  },

  // upload pdf文件上传
  UploadPDF (data) {
    return httpPost('/api/open/portfolio/reports/upload', {
      ...data,
    })
  },

  //  获取历史价格 交易数据
  HistoryPrices (data) {
    return httpPost('/api/open/portfolio/history-prices', {
      ...data,
    })
  },

  // 调整权重 重新计算组合指标
  RecalculateMetrics (data) {
    return httpPost('/api/open/portfolio/recalculate-metrics', {
      ...data,
    })
  },

  //  机器人列表
  RobotsList () {
    return httpGet('/api/open/robots/' + window.robotCode, {

    })
  },

  //  获取组合指标公式
  MetricFormulas (data) {
    return httpPost('/api/open/portfolio/metric-formulas', {
      ...data,
    })
  },

}
